import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseFeeTemplateOptionsProps<T> = {
  filters?: {
    search?: string
    category?: string
  }
  mapper?: (data: any) => T,
}

export const useFeeTemplateOptions = <T,>({
  filters: { search = '', category } = {},
  mapper = Mapper.default<T>(),
}: UseFeeTemplateOptionsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['feeTemplateOptions', search, category],
    queryFn: () => {
      return privateAxios.get('/billing/fee_template_options', {
        params: {
          search,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
